import {
  getAllIndexes,
} from "../../../../common/functions/Functions_General";
import { GameData } from "../../gamestate/gameData";
import { GameColumn } from "../GameColumn";


export class ExpandAnimation {
  private parent: PIXI.Container = new PIXI.Container();
  private animsContainer: PIXI.Container = new PIXI.Container();
  private activeGameData: GameData;
  private pillarsOfLights: Array<PIXI.Sprite>;
  private tweenAnimation: Array<PIXI.tween.Tween>;

  //--ticker update
  private expandAnimationTicker: PIXI.ticker.Ticker;
  private tickerExpandTimerPerSymbol: number = 500; //500;
  private expandSymbolColumnLocations: Array<number>;
  private tickerDelta: number = 0;
  private countersAdded: number = 0;
  private activeExpandSymbolIndex: number = 0;
  private listOfSymbolsToRemove: Array<Array<number>>;
  private allColumns: Array<GameColumn>;

  private expandAnimReelIndex: number = 0;
  private skip: boolean = false;
  private isExpanding: boolean = false;
  constructor(
    parent: PIXI.Container,
    activeGameData: GameData,
    mask: PIXI.Graphics
  ) {
    parent.addChild(this.parent);
    this.parent.addChild(this.animsContainer);
    this.activeGameData = activeGameData;
    this.activeGameData;
    this.parent.x = this.activeGameData.size[0] / 2;
    this.parent.y = this.activeGameData.size[1] / 2 - 100;

    this.pillarsOfLights = [];
    this.tweenAnimation = [];
    this.parent.mask = mask;

    for (let i = 0; i < 5; i++) {
      this.pillarsOfLights[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame("lightWhite.png")
      );
      this.animsContainer.addChild(this.pillarsOfLights[i]);
      this.pillarsOfLights[i].tint = 0xf3d485; // 0xffddaa; //0xF5cc88//0xF08822
      this.pillarsOfLights[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      this.pillarsOfLights[i].anchor.set(0.5, 0);
      this.pillarsOfLights[i].y = -420;
      this.pillarsOfLights[i].x = -530 + i * 265;

      this.tweenAnimation[i] = PIXI.tweenManager.createTween(
        this.pillarsOfLights[i]
      );
      this.tweenAnimation[i]
        .from({ scale: { x: 1, y: 1.3 }, alpha: 1 })
        .to({ scale: { x: 1.5, y: 1.5 }, alpha: 1 });
      this.tweenAnimation[i].time = 1000;
      this.tweenAnimation[i].pingPong = true;
      this.tweenAnimation[i].loop = true;
      // this.tweenAnimation[i].start()
    }

    this.clear();

    //--

    this.expandAnimationTicker = new PIXI.ticker.Ticker();
    this.expandAnimationTicker.stop();
    this.expandAnimationTicker.add(() => {
      if (
        Date.now() - this.tickerDelta > this.tickerExpandTimerPerSymbol &&
        this.skip == false
      ) {
        if (this.countersAdded < this.listOfSymbolsToRemove.length) {
          this.activeGameData.gameBar.setPlayButtonIndex(1);
          // console.log(this.listOfSymbolsToRemove[0][0]);
          if (this.isExpanding == false) {
            this.isExpanding = true;
          }

          // resetAllBtns(activeGameData);
          // setAllowedInputs(activeGameData);

          let colIndex: number = this.listOfSymbolsToRemove[
            this.countersAdded
          ][0];
          let rowIndex: number = this.listOfSymbolsToRemove[
            this.countersAdded
          ][1];

          //tiles system contains two invisible rows (for spin purpose) index 0 and 1
          this.allColumns[colIndex]
            .getSprite(rowIndex)
            .setCurrentFrame(this.activeExpandSymbolIndex);

          this.allColumns[colIndex].getSprite(rowIndex).playScaleTween();

          //-visible row only , hence why -2 to the rowindex
          this.activeGameData.mainGame
            .getExpandingHighlightTile()
            .playSelected([colIndex, rowIndex - 2]);
          this.countersAdded++;

          if (this.activeGameData.expandAnimSound.playing()) {
            this.activeGameData.expandAnimSound.stop();
          }
          this.activeGameData.expandAnimSound.play("win");
          if (this.countersAdded > 0 && this.countersAdded % 3 == 0) {
            // console.log("reeel expandComplete", this.expandSymbolColumnLocations)

            this.activeGameData.mainGame
              .getPostExpandAnim()
              .playSelectedReel(
                this.expandSymbolColumnLocations[this.expandAnimReelIndex]
              );
            this.expandAnimReelIndex++;

            if (this.activeGameData.sound_expandComlete.playing) {
              this.activeGameData.sound_expandComlete.stop();
            }
            this.activeGameData.sound_expandComlete.play("sound");
          } else {
            //nothing for moment
          }
        } else {

          this.activeGameData.mainGame.displayExpandSkipBtn(false);
          this.expandAnimationTicker.stop(); //stop ticker when completed the filling
          this.activeGameData.mainGame.winlineExpanded();
          if (this.isExpanding == true) {
            this.isExpanding = false;
          } //expandComplete
        }
        this.tickerDelta = Date.now();
      } else if (this.skip == true) {
        this.skipExpandToResult();
      }
    });
  }

  public getIsActive=():boolean=>
  {
    return this.isExpanding;
  }

  public onSkipClick = (): void => {
    if (this.getSkippable()) {
      // this.skip=true;
      this.isExpanding = false;
    
      this.skipExpandToResult();
    }
  };

  public reloadSkip=():void=>
  {
    this.isExpanding = false;
    
    this.skipExpandToResult();
  }
  public getSkippable = (): boolean => {
    if (this.isExpanding && this.skip == false) {
      return true;
    } else {
      return false;
    }
  };

  private skipExpandToResult = (): void => {
    this.activeGameData.mainGame.displayExpandSkipBtn(false);
    this.activeGameData.mainGame.setExpandedWinlinesActive(false);
    this.activeGameData.mainGame.setExpandedWinlinesActive(false);
    this.expandAnimationTicker.stop(); //stop ticker when completed the filling
    this.activeGameData.mainGame.winlineExpanded();
    // console.log(this.expandSymbolColumnLocations)
    for (let i = 0; i < this.expandSymbolColumnLocations.length; i++) {
      this.activeGameData.mainGame
        .getPostExpandAnim()
        .playSelectedReel(this.expandSymbolColumnLocations[i]);
    }
  };

  public clear = (): void => {
    if( this.expandAnimationTicker!=undefined)
    {
      this.expandAnimationTicker.stop(); //stop ticker when completed the filling
    }
    
    for (let i = 0; i < this.pillarsOfLights.length; i++) {
      this.pillarsOfLights[i].alpha = 0;
      this.tweenAnimation[i].stop();
    }
    this.isExpanding=false;
  };
  public showPillar = (pillarindexArr: Array<number>): void => {
    this.clear();
    this.isExpanding=true;
    for (let i = 0; i < pillarindexArr.length; i++) {
      this.tweenAnimation[pillarindexArr[i]].reset();
      this.tweenAnimation[pillarindexArr[i]].start();
    }
    this.animateExpand();
  };

  public animateExpand = (): void => {
    //-array that need to be changed

    // console.log('ANIM expand')
    this.allColumns = this.activeGameData.mainGame.getAllColumns();
    this.expandSymbolColumnLocations = getAllIndexes(
      this.activeGameData.GameContext().bonusGameResult.expandedReels,
      true
    );
    this.activeExpandSymbolIndex =
      this.activeGameData.GameContext().expandingSymbol - 1; //-1 because server daata start with 1 but locally it start wiht 0
    this.listOfSymbolsToRemove = []; //make a list where to add

    for (let i = 0; i < this.expandSymbolColumnLocations.length; i++) {
      //-go to the  selected columns and copy the  locations of new symbols that needs to be swapped;

      let offset = 2;

      for (let j = 0 + offset; j < 3 + offset; j++) {
        ///- allows to only push symbol that arent already bonus symbol
        // let currentSymbolInTile = this.allColumns[
        //   this.expandSymbolColumnLocations[i]
        // ]
        //   .getSprite(j)
        //   .getActiveIndex();
        // console.log(currentSymbolInTile,currentBonusSymbolIndex)
        // if (currentSymbolInTile != this.activeExpandSymbolIndex) {
        //   this.listOfSymbolsToRemove.push([
        //     this.expandSymbolColumnLocations[i],
        //     j,
        //   ]);
        // }

        //-allows to push all symbolseven if the symbol is alrady bonus
        this.listOfSymbolsToRemove.push([
          this.expandSymbolColumnLocations[i],
          j,
        ]);
      }

      //-replace symbols
    }

    //-start the ticker to animate expanding
    this.tickerDelta = Date.now();
    this.countersAdded = 0;
    this.expandAnimReelIndex = 0;
    this.skip = false;
    // this.isExpanding=true;
    this.expandAnimationTicker.start();
    this.activeGameData.mainGame.displayExpandSkipBtn(true);
   
  };
}
